module.exports = __webpack_public_path__ + "static/media/ZillaSlab-SemiBold.c003d19d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ZillaSlab-SemiBold.ttf
// module id = 3831
// module chunks = 68